var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustriLogistikk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(8366 1349)",
    fill: "#b7dc8f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(-8366 -1349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(8366 1349)",
    fill: "#b7dc8f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101-2",
    "data-name": "Ellipse 101",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(8366 1349)",
    fill: "#b7dc8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_18",
    "data-name": "Mask Group 18",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(8359.346 1343.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(12.138 26.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_917",
    "data-name": "Rectangle 917",
    width: 85.032,
    height: 42.887,
    transform: "translate(0 32.168)",
    fill: "#b4b1b1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_918",
    "data-name": "Rectangle 918",
    width: 85.032,
    height: 4.528,
    transform: "translate(0 27.639)",
    fill: "#e1e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4452",
    "data-name": "Path 4452",
    d: "M26.363,49.614l-8.916-8.906-.141,8.634L8.663,40.708l-.592,39,5.75.028L17.26,52.16l-.4,24.069Z",
    transform: "translate(-0.922 -4.651)",
    fill: "#878585"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310",
    transform: "translate(70.705 38.763)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_919",
    "data-name": "Rectangle 919",
    width: 3.091,
    height: 4.5,
    transform: "translate(1.287 7.074)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_920",
    "data-name": "Rectangle 920",
    width: 3.091,
    height: 4.5,
    transform: "translate(5.665 7.074)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_921",
    "data-name": "Rectangle 921",
    width: 3.091,
    height: 4.5,
    transform: "translate(1.287 1.287)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_922",
    "data-name": "Rectangle 922",
    width: 3.091,
    height: 4.5,
    transform: "translate(5.665 1.287)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4453",
    "data-name": "Path 4453",
    d: "M79.825,43.763V56.615H89.859V43.763Zm5.656,1.287h3.091v4.5H85.481Zm-4.378,0h3.091v4.5H81.1Zm3.091,10.278H81.1v-4.5h3.091Zm4.378,0H85.481v-4.5h3.091Z",
    transform: "translate(-79.825 -43.763)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311",
    transform: "translate(56.246 38.763)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 3.091,
    height: 4.5,
    transform: "translate(1.287 7.074)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_924",
    "data-name": "Rectangle 924",
    width: 3.091,
    height: 4.5,
    transform: "translate(5.656 7.074)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_925",
    "data-name": "Rectangle 925",
    width: 3.091,
    height: 4.5,
    transform: "translate(1.287 1.287)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_926",
    "data-name": "Rectangle 926",
    width: 3.091,
    height: 4.5,
    transform: "translate(5.656 1.287)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    "data-name": "Path 4454",
    d: "M63.5,43.763V56.615H73.535V43.763Zm5.656,1.287h3.091v4.5H69.157Zm-4.378,0H67.87v4.5H64.779ZM67.87,55.328H64.779v-4.5H67.87Zm4.378,0H69.157v-4.5h3.091Z",
    transform: "translate(-63.501 -43.763)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312",
    transform: "translate(70.705 58.266)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_927",
    "data-name": "Rectangle 927",
    width: 3.091,
    height: 4.5,
    transform: "translate(1.287 7.074)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 3.091,
    height: 4.5,
    transform: "translate(5.665 7.074)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_929",
    "data-name": "Rectangle 929",
    width: 3.091,
    height: 4.5,
    transform: "translate(1.287 1.287)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 3.091,
    height: 4.5,
    transform: "translate(5.665 1.287)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    "data-name": "Path 4455",
    d: "M79.825,65.782V78.634H89.859V65.782Zm5.656,1.287h3.091v4.5H85.481Zm-4.378,0h3.091v4.5H81.1Zm3.091,10.278H81.1v-4.5h3.091Zm4.378,0H85.481v-4.5h3.091Z",
    transform: "translate(-79.825 -65.782)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4456",
    "data-name": "Path 4456",
    d: "M20.116,42.668a3.307,3.307,0,1,1-3.307-3.307A3.312,3.312,0,0,1,20.116,42.668Z",
    transform: "translate(-1.543 -4.497)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4457",
    "data-name": "Path 4457",
    d: "M10.188,42.668a3.307,3.307,0,1,1-3.307-3.307A3.312,3.312,0,0,1,10.188,42.668Z",
    transform: "translate(-0.408 -4.497)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314",
    transform: "translate(4.096 35.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4458",
    "data-name": "Path 4458",
    d: "M9.37,42.789A2.367,2.367,0,1,1,7,40.422,2.37,2.37,0,0,1,9.37,42.789Z",
    transform: "translate(-4.626 -40.422)",
    fill: "#f0efef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313",
    transform: "translate(0 2.367)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_931",
    "data-name": "Rectangle 931",
    width: 2.367,
    height: 36.921,
    fill: "#f0efef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_932",
    "data-name": "Rectangle 932",
    width: 2.367,
    height: 36.921,
    transform: "translate(2.367)",
    fill: "#d2d0d0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315",
    transform: "translate(3.345 46.316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_933",
    "data-name": "Rectangle 933",
    width: 3.119,
    height: 3.044,
    transform: "translate(3.128)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_934",
    "data-name": "Rectangle 934",
    width: 3.128,
    height: 3.044,
    fill: "#878585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316",
    transform: "translate(3.345 54.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_935",
    "data-name": "Rectangle 935",
    width: 3.119,
    height: 3.044,
    transform: "translate(3.128)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_936",
    "data-name": "Rectangle 936",
    width: 3.128,
    height: 3.044,
    fill: "#878585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317",
    transform: "translate(3.345 61.799)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_937",
    "data-name": "Rectangle 937",
    width: 3.119,
    height: 3.044,
    transform: "translate(3.128)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    width: 3.128,
    height: 3.044,
    fill: "#878585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318",
    transform: "translate(33.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4459",
    "data-name": "Path 4459",
    d: "M41.419,23.26H37.8V30.3H47.835V23.26Z",
    transform: "translate(-37.802 -2.658)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4460",
    "data-name": "Path 4460",
    d: "M59.163,23.26H49.13V30.3H59.163Z",
    transform: "translate(-39.096 -2.658)",
    fill: "#444343"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    width: 6.417,
    height: 12.063,
    transform: "translate(10.034 8.54)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_940",
    "data-name": "Rectangle 940",
    width: 6.417,
    height: 12.063,
    transform: "translate(3.617 8.54)",
    fill: "#7b7a7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_941",
    "data-name": "Rectangle 941",
    width: 4.059,
    height: 3.448,
    transform: "translate(10.034)",
    fill: "#444343"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_942",
    "data-name": "Rectangle 942",
    width: 4.059,
    height: 3.448,
    transform: "translate(5.975)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4461",
    "data-name": "Path 4461",
    d: "M48.3,3.893H41.885V8.985H48.3Z",
    transform: "translate(-38.268 -0.445)",
    fill: "#b43c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4462",
    "data-name": "Path 4462",
    d: "M49.13,8.985h6.417V3.893H49.13Z",
    transform: "translate(-39.096 -0.445)",
    fill: "#872d2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319",
    transform: "translate(6.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4463",
    "data-name": "Path 4463",
    d: "M10.861,23.26H7.244V30.3H17.278V23.26Z",
    transform: "translate(-7.244 -2.658)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4464",
    "data-name": "Path 4464",
    d: "M28.606,23.26H18.572V30.3H28.606Z",
    transform: "translate(-8.539 -2.658)",
    fill: "#444343"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 6.417,
    height: 12.063,
    transform: "translate(10.034 8.54)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_944",
    "data-name": "Rectangle 944",
    width: 6.417,
    height: 12.063,
    transform: "translate(3.617 8.54)",
    fill: "#7b7a7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 4.059,
    height: 3.448,
    transform: "translate(10.034)",
    fill: "#444343"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 4.059,
    height: 3.448,
    transform: "translate(5.984)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4465",
    "data-name": "Path 4465",
    d: "M17.744,3.893H11.328V8.985h6.417Z",
    transform: "translate(-7.711 -0.445)",
    fill: "#b43c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4466",
    "data-name": "Path 4466",
    d: "M18.572,8.985h6.417V3.893H18.572Z",
    transform: "translate(-8.539 -0.445)",
    fill: "#872d2d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_947",
    "data-name": "Rectangle 947",
    width: 3.758,
    height: 4.669,
    transform: "translate(12.692 22.98)",
    fill: "#f0efef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_948",
    "data-name": "Rectangle 948",
    width: 3.758,
    height: 4.669,
    transform: "translate(20.264 22.98)",
    fill: "#f0efef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_949",
    "data-name": "Rectangle 949",
    width: 3.758,
    height: 4.669,
    transform: "translate(39.759 22.98)",
    fill: "#f0efef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_950",
    "data-name": "Rectangle 950",
    width: 3.758,
    height: 4.669,
    transform: "translate(47.321 22.98)",
    fill: "#f0efef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4467",
    "data-name": "Path 4467",
    d: "M61.687,80.831l-30.27-30.27,1.907,30.27Z",
    transform: "translate(-3.589 -5.777)",
    fill: "#878585"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321",
    transform: "translate(16.694 42.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4468",
    "data-name": "Path 4468",
    d: "M31.907,54.9a6.529,6.529,0,1,1-6.529-6.529A6.527,6.527,0,0,1,31.907,54.9Z",
    transform: "translate(-18.848 -48.366)",
    fill: "#b43c3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320",
    transform: "translate(0 6.529)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_951",
    "data-name": "Rectangle 951",
    width: 6.529,
    height: 25.695,
    fill: "#b43c3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_952",
    "data-name": "Rectangle 952",
    width: 6.529,
    height: 25.695,
    transform: "translate(6.529)",
    fill: "#872d2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322",
    transform: "translate(45.705 44.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4469",
    "data-name": "Path 4469",
    d: "M73.914,65.782H66.821l7.093,7.093Z",
    transform: "translate(-53.34 -52.3)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4470",
    "data-name": "Path 4470",
    d: "M65.082,64.043,51.6,50.561l1.907,30.27h8.634V64.043Z",
    transform: "translate(-51.601 -50.561)",
    fill: "#878585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4471",
    "data-name": "Path 4471",
    d: "M66.442,65.782H63.5V82.57H73.535v-9.7Z",
    transform: "translate(-52.961 -52.3)",
    fill: "#444343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324",
    transform: "translate(34.554 42.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4472",
    "data-name": "Path 4472",
    d: "M52.07,54.9a6.529,6.529,0,1,1-6.529-6.529A6.527,6.527,0,0,1,52.07,54.9Z",
    transform: "translate(-39.011 -48.366)",
    fill: "#b43c3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323",
    transform: "translate(0 6.529)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953",
    "data-name": "Rectangle 953",
    width: 6.529,
    height: 25.695,
    fill: "#b43c3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_954",
    "data-name": "Rectangle 954",
    width: 6.529,
    height: 25.695,
    transform: "translate(6.529)",
    fill: "#872d2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326",
    transform: "translate(12.899 35.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4473",
    "data-name": "Path 4473",
    d: "M19.3,42.789a2.367,2.367,0,1,1-2.367-2.367A2.37,2.37,0,0,1,19.3,42.789Z",
    transform: "translate(-14.563 -40.422)",
    fill: "#f0efef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(0 2.367)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 2.367,
    height: 36.921,
    fill: "#f0efef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_956",
    "data-name": "Rectangle 956",
    width: 2.367,
    height: 36.921,
    transform: "translate(2.367)",
    fill: "#d2d0d0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327",
    transform: "translate(12.138 46.316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_957",
    "data-name": "Rectangle 957",
    width: 3.119,
    height: 3.044,
    transform: "translate(3.128)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_958",
    "data-name": "Rectangle 958",
    width: 3.128,
    height: 3.044,
    fill: "#878585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328",
    transform: "translate(12.138 54.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_959",
    "data-name": "Rectangle 959",
    width: 3.119,
    height: 3.044,
    transform: "translate(3.128)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_960",
    "data-name": "Rectangle 960",
    width: 3.128,
    height: 3.044,
    fill: "#878585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(12.138 61.799)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_961",
    "data-name": "Rectangle 961",
    width: 3.119,
    height: 3.044,
    transform: "translate(3.128)",
    fill: "#5a5959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_962",
    "data-name": "Rectangle 962",
    width: 3.128,
    height: 3.044,
    fill: "#878585"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(66.28 65.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4474",
    "data-name": "Path 4474",
    d: "M81.159,80.13,79.825,78.8V80.13Z",
    transform: "translate(-75.4 -74.362)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4475",
    "data-name": "Path 4475",
    d: "M80.588,79.558H79.254V78.224L74.829,73.79v9.7h9.7Z",
    transform: "translate(-74.829 -73.79)",
    fill: "#878585"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustriLogistikk);
export default __webpack_public_path__ + "static/media/Industri-logistikk.2a90f9aa4af43e7e325bb14d53f947b6.svg";
export { ForwardRef as ReactComponent };